import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const noteCreateOrUpdate = (data: unknown, id?: number) => {
  const method = id ? "PUT" : "POST";
  const url = id ? `/general-notes/${id}` : "/general-notes";
  return axios({
    method,
    url,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getNotes = (params: any) => {
  return axios({
    method: "GET",
    url: "/general-notes",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const archiveNote = (id: number) => {
  return axios({
    method: "DELETE",
    url: `/general-notes/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const shareNote = (id: number, data: unknown) => {
  return axios({
    method: "POST",
    url: `/general-notes/${id}/share`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
